import React, { Fragment } from 'react';
import { uploadMedia } from '../../api/mediaApi';
import { useFeed } from 'contexts/FeedContext';
import { toast } from "react-toastify";

function UploadMedia() {
    const { loadFeeds } = useFeed();

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/mp4', 'image/mov', 'image/avi'];
        if (!allowedTypes.includes(file.type)) {
            toast('Please upload valid image.')
            return;
        }
        const formData = new FormData();
        formData.append('media', file);

        const result = await uploadMedia(formData);

        if (result?.success && result.media?.url) {
            toast(result?.message)
            e.target.value = '';
            loadFeeds(); // calling feed API
        }
    }

    return (
        <Fragment>
            <div className="md:max-w-md w-full bg-white rounded pt-3 pb-2 text-center items-center justify-center border-2 border-gray-300 border-dashed text-gray-500 font-[sans-serif]">
                <label className="bg-white font-semibold text-base rounded w-full h-8 gap-3 flex items-center justify-center cursor-pointer mx-auto">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-10 mb-2 fill-gray-500"
                        viewBox="0 0 32 32"
                    >
                        <path
                            d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                            data-original="#000000"
                        />
                        <path
                            d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                            data-original="#000000"
                        />
                    </svg>
                    Upload file
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden"
                    />
                </label>
                <p className='text-[10px] font-medium'>Supported formats are: JPG, JPEG, PNG, MP4, MOV, and AVI.</p>
            </div>
        </Fragment>
    )
}
export default UploadMedia;